/*
 * @Author: your name
 * @Date: 2021-08-18 18:07:47
 * @LastEditTime: 2021-11-08 17:46:31
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\router\index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { GET_TOKEN } from '@/utils/auth.js'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: () =>
        import(
          /* webpackChunkName:"group-index" */ '@/views/home/Home.vue'
        )
    },
    {
      path: '/login',
      name: 'Login',
      component: () =>
        import(
          /* webpackChunkName:"group-index" */ '@/views/login/Login.vue'
        )
    },
    {
      path: '/user',
      name: 'User',
      component: () =>
        import(
          /* webpackChunkName:"group-user" */ '@/views/user/User.vue'
        ),
      redirect: { name: 'accountSetting' },
      children: [
        {
          path: 'accountSetting',
          name: 'accountSetting',
          component: () => import(/* webpackChunkName:"group-user" */ '@/views/user/account-setting.vue')
        },
        {
          path: 'loginRecord',
          name: 'loginRecord',
          component: () => import(/* webpackChunkName:"group-user" */ '@/views/user/login-info.vue')
        }
      ]
    },
    {
      path: '/control/:id',
      name: 'UserControl',
      component: () =>
        import(
          /* webpackChunkName:"group-user" */ '@/views/user/control.vue'
        )
    },
    {
      path: '/404',
      name: '404',
      meta: { title: '404 NOT FOUND' },
      hidden: true,
      component: () =>
        import(
          /* webpackChunkName:"group-index" */ '@/views/errors/'
        )
    },

    {
      path: '*',
      hidden: true,
      redirect: { name: '404' }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const letoff = ['/login', '/LOGIN', '/404']
  if (letoff.includes(to.path)) {
    next()
  } else if (
    (to.path !== 'login' ||
      to.path !== '/LOGIN') &&
    GET_TOKEN()
  ) {
    next()
  } else {
    Message({
      type: 'warning',
      message: '请登录！'
    })
    next('/login')
  }
})

export default router
